export function getTouchDirection(angle, range) {
  var direction = false,
      gap = Math.abs(90 - Math.abs(angle));
      
  if (gap >= 90 - range) {
    direction = 'horizontal';
  } else if (gap <= range) {
    direction = 'vertical';
  }

  return direction;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/tiny-slider/src/helpers/getTouchDirection.js
// module id = 79
// module chunks = 0